export type SignupAccountType = 'brand_ambassador' | 'organization';

export function SignupPath({ value, onChange, disabled = false }: {
  value: SignupAccountType;
  onChange: (value: SignupAccountType) => void;
  disabled?: boolean;
}) {
  return <fieldset className="consent-fieldset" disabled={disabled}>
    <legend>How would you like to join BFC?</legend>
    <label className="consent-option"><input type="radio" name="signup-path" checked={value === 'brand_ambassador'} onChange={() => onChange('brand_ambassador')} /><span>Join as a BA</span></label>
    <label className="consent-option"><input type="radio" name="signup-path" checked={value === 'organization'} onChange={() => onChange('organization')} /><span>Join an organisation</span></label>
    <p className="muted">{value === 'brand_ambassador'
      ? 'Create a talent profile for campaign work.'
      : 'Create your login. An administrator must add you to an organisation before you can access its work.'}</p>
  </fieldset>;
}
